var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReservaSalasReunioes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "reserva-salas-reunioes",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reserva-salas-reunioes_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.8,120.9l4.9,6.6c2.4-1.8,4.6-3.7,6.7-5.9l-5.9-5.7C115.7,117.9,113.8,119.6,111.8,120.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.5,127.8l2.4,7.8c2.8-0.9,5.6-2,8.2-3.3l-3.7-7.3C103.2,126.1,100.9,127.1,98.5,127.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.1,110.1l6.8,4.6c1.7-2.5,3.1-5.1,4.3-7.8l-7.5-3.4C124.7,105.9,123.5,108.1,122.1,110.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "81.5,81.4 58.5,81.4 58.5,89.6 89.7,89.6 89.7,48.5 81.5,48.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.9,42.5v15.2c-3.9-6.2-9-11.5-15.1-15.6c-8.7-5.9-18.9-9-29.4-9c-14,0-27.2,5.5-37.1,15.4 c-9.9,9.8-15.4,23-15.4,37s5.5,27.2,15.4,37.1c9.9,9.9,23.1,15.4,37.1,15.4c2.3,0,4.6-0.1,6.8-0.4l-1.1-8.1 c-1.9,0.2-3.8,0.4-5.8,0.4c-24.4,0-44.3-19.9-44.3-44.3s20-44.4,44.4-44.4c15.8,0,30.2,8.4,38.1,21.7h-14.1V71h28.7V42.5H129.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.5,89.1c0,0.4-0.1,0.9-0.1,1.3l0,0c-0.2,2.1-0.6,4.1-1.1,6.1l7.9,2.1c0.7-2.9,1.2-5.8,1.5-8.8l0,0 c0-0.3,0-0.5,0.1-0.8L129.5,89.1L129.5,89.1z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservaSalasReunioes);
export default __webpack_public_path__ + "static/media/reserva-salas-reunioes.fefa890e9d65bdf8a58c59ecc1da91a6.svg";
export { ForwardRef as ReactComponent };